<form class="forms" [formGroup]="telefoneForm">
  <div class="input-multi">
    <select
        *ngIf="!readOnly"
        class="form-control select-small"
        name="tipoTelefone"
        id="tipoTelefone"
        formControlName="tipoTelefone">
      <option [value]="tipoCelular" [selected]="tipoTelefone.value === tipoCelular">Celular</option>
      <option [value]="TipoTelefoneEnum.RESIDENCIAL" *ngIf="!needsConfirmation" [selected]="tipoTelefone.value === TipoTelefoneEnum.RESIDENCIAL">Residencial</option>
    </select>
    <div class="input-multi-container">
      <div class="removable-container">
        <div style="width: 100%">
          <input
              class="form-control"
              type="text"
              [placeholder]="isResidencial ? '(00) 0000-0000' : '(00) 00000-0000'"
              required
              name="telefone"
              formControlName="telefone"
              [minLength]="isResidencial ? 13 : 14"
              [maxLength]="isResidencial ? 14 : 15"
              appShowErrorMessages
              requiredMessage="O campo Telefone é obrigatório"
              appOnlyNumberRestrictive
              inputmode="numeric"
              [value]="telefoneForm.get('telefone').value | telefone">
        </div>
        <p class="remove-item-btn" (click)="selfDestruct()" *ngIf="isRemovable"><em class="fa fa-trash"></em></p>
      </div>
    </div>
  </div>
</form>

<app-loader-circles *ngIf="showLoader"></app-loader-circles>
<app-new-modal-message #smsModal [showFecharBtn]="false"></app-new-modal-message>

